import MenuIcon from '@mui/icons-material/Menu';
import { Stack } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useContext,useEffect,useState } from 'react';
import { UserContext } from '../../../context/UserContext';
import { WebFormContext } from '../../../context/WebFormContext';
import { ChamadoChecklist,FormToFilling,modeloType,styleOptionsProp } from '../../../types/new-form-filling/types';
import OpenTicketModal from '../modal/OpenTicketModal ';
import { ButtonChamado } from './ButtonChamado';
export default function NewFormFillingHeader({
  form,
  styleOptions,
  setOpen,
}: {
  form: FormToFilling,
  styleOptions: styleOptionsProp,
  setOpen: Function,
}) {
  const colorHeader = styleOptions?.colorHeader;
  const fontHeader = styleOptions?.fontHeader;
  const logo = styleOptions?.logo;
  const { ForceUpdate } = useContext(WebFormContext);
  const [chamados, setChamados] = useState<ChamadoChecklist[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { logado } = useContext(UserContext);

  useEffect(() => {
    if (!form.chamados) {
      form.chamados = chamados;
    } if (form.chamados) {
      form.chamados = chamados;
    } if (!chamados?.length) {
      delete form.chamados;
    }
    ForceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chamados]);

  return (
    <AppBar
      position='static'
      sx={{
        backgroundColor: colorHeader ? colorHeader : '#643E91',
        color: fontHeader?.color && fontHeader?.color,
        fontSize: fontHeader?.fontSize && fontHeader?.fontSize,
        fontFamily: fontHeader?.fontFamily && fontHeader?.fontFamily,
      }}>
      {openModal && <OpenTicketModal
        openModal={openModal}
        limite={form?.chamadosConfig?.limiteChamado}
        setOpenModal={setOpenModal}
        modelos={form?.chamadosConfig?.tipoChamado as modeloType[] | undefined}
        chamados={chamados}
        setChamados={setChamados}
      />}
      <Toolbar sx={{ paddingTop: '10px', paddingBottom: '10px' }}>
        <IconButton
          onClick={() => setOpen(true)}
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        <Stack
          width={'100%'}
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={1}>
          {logo && (
            <img
              className='imgLogoStyle'
              src={logo}
              alt={form?.nome}
            />
          )}
          <Typography
            textAlign='center'
            variant={`${window.navigator.maxTouchPoints > 0 ? 'h6' : 'h5'}`}
            component="div"
            sx={{ flexGrow: 1, wordBreak: 'break-word' }}>
            {form?.nome}
          </Typography>
        </Stack>
        {form.chamadosConfig && form?.chamadosConfig?.tipoChamado?.length > 0
          && logado
          && <ButtonChamado chamados={chamados} setOpenModal={setOpenModal} ticketConfig={form?.ticketConfig as { limit: number, mandatory: boolean }} />}
      </Toolbar>
    </AppBar>
  );
}
